



























import { Tab, Tabs } from 'vant';
import { Vue, Component } from 'vue-property-decorator';
import { Banner } from '@/components';
import VoteList from './components/VoteList.vue';
import { getBaseinfo } from './api/index';
import { namespace, State } from 'vuex-class';
import * as mutationTypes from './store/mutation-types';
import * as config from './config';

const Module = namespace('AssociationEcologyMeeting2019');
Vue.use(Tab).use(Tabs);
@Component({
  components: {
    VoteList,
    Banner,
  },
})
export default class List extends Vue {
  @Module.Action changeType!: (index: number) => void;
  @Module.State('type') type!: number;
  @Module.Mutation(mutationTypes.CHANGE_LOADSTATUS_DATA)
  changeLoadstatus!: (loadstatus: number) => void;
  options = config.OPTHINES;
  baseInfo: object = {};
  ifChangeType = false;
  created() {
    getBaseinfo().then((res: any) => (this.baseInfo = res.data));
    this.changeLoadstatus(0);
  }
  changeTypeFuc(index: number) {
    this.changeType(index);
    this.ifChangeType = !this.ifChangeType;
  }
  // 开始搜索
  enterSearchpage() {
    this.$router.push({ path: './Searchpage' });
  }
}
